import React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { Icon } from 'antd';

export default connect(null, { goBack })(
    ({ goBack }) => (
        <a className="back-button" onClick={goBack}>
            <Icon type="arrow-left" />
        </a>
    )
);



// WEBPACK FOOTER //
// ./src/components/common/elements/BackButton.js